import { basePath } from "../../next.config";

export const BASE_PATH = basePath || "";
export const CONTACT_NAV_URL = "https://www.nav.no/still-sporsmal";
